import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import Training from '../../components/views/admin/Training'
import injectRole from '../../components/HOC/injectRole'

import { TRoles, TRoutes } from '../../shared/const'

/**
 * Die Schulung „Neu im Schuljahr" — nur für die Verwaltung.
 *
 * Der Rollenschnitt steht auch hier und nicht nur an der Schnittstelle: Wer die
 * Adresse errät, soll keine halbe Seite mit Fehlermeldungen sehen.
 */
function TrainingPage(props) {
	if (![TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return <Redirect to={TRoutes.DASHBOARD} />

	return <Training />
}

TrainingPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(TrainingPage)
